import { Navigate, Route, Routes } from "react-router-dom";

import { isAuthenticated } from "../utils/auth";
import { MapProvider } from "../context/MapContext";
import MapSettings from "../pages/SalesManagement/EnterpriseSettings/Map/MapSettings";
import EnterpriseSettings from "../pages/SalesManagement/EnterpriseSettings/EnterpriseSettings";
import SimulatorConfig from "../pages/SalesManagement/EnterpriseSettings/Simulator/SimulatorConfig";
import ModelContracts from "../pages/SalesManagement/EnterpriseSettings/ModelContracts/ModelContracts";
import Teams from "../pages/Teams/Teams";
import EmailConfig from "../pages/SalesManagement/EnterpriseSettings/Emails/EmailConfig.jsx";

const PrivateRoute = ({ children }) => {
  const auth = isAuthenticated();
  return auth ? children : <Navigate to="/" />;
};

export const EnterpriseSettingsRoute = () => (
  <MapProvider>
    <PrivateRoute>
      <Routes>
        <Route path="/:id" element={<EnterpriseSettings />} />
        <Route path="/map/:id" element={<MapSettings />} />
        <Route path="/teams/:id" element={<Teams />} />
        <Route path="/simulator/:id" element={<SimulatorConfig />} />
        <Route path="/modelContracts/:id" element={<ModelContracts />} />
        <Route path="/emailShippingDays/:id" element={<EmailConfig />} />
        <Route path="/clickSignConfig/:id" element={< EmailConfig/>} />
      </Routes>
    </PrivateRoute>
  </MapProvider>
);
